export const formatTimeHM = (isoString: string) => {
  const date = new Date(isoString);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} | ${hours}:${minutes}`;
}
